export const consolidateManagerScope = (managersRes: any[]) => {
    const faculties = new Set<string>();
    const departments = new Set<string>();
    const courses = new Set<string>();
  
    managersRes.forEach((manager) => {
      if (manager.idFaculty) faculties.add(manager.idFaculty);
      if (manager.idDepartament) departments.add(manager.idDepartament);
      if (manager.idCourse) courses.add(manager.idCourse);
    });
  
    return {
      faculties: Array.from(faculties),
      departments: Array.from(departments),
      courses: Array.from(courses),
    };
  };
  